const src = import.meta.ROLLUP_FILE_URL_XivDCLKvo3rsiwL$eU0pkA;
export default {
  src,
  srcSet: src + " " + 324 + "w",
  width: 324,
  height: 480,
};